<template>
    <div class="alert-box success">
        {{ message }}
    </div>
</template>
<script>
    export default {
        name: 'success',
        props: ['message'],
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/components/ui/success.vue